import { ITrainingTypeValues } from './training-type-form-types'
import {
  ITrainingType,
  ITrainingTypeUpsert,
} from '../../../../interfaces'

export const trainingTypeToTrainingTypeValues = (
  trainingType: ITrainingType | undefined,
): ITrainingTypeValues | undefined => {
  if (!trainingType) {
    return undefined
  }

  return {
    name: trainingType?.name,
    objectives: trainingType?.objectives,
    trainingCategoryId: trainingType?.trainingCategory?.id ?? null,
    defaultExpirationMonths: String(trainingType?.defaultExpirationMonths),
    acReference: trainingType?.acReference,
    sortOrder: String(trainingType?.sortOrder),
    isActive: trainingType?.isActive,
    documents: trainingType?.documents || [],
  }
}

export const trainingTypeValuesToTrainingTypeAddUpsert = (
  trainingTypeValues: ITrainingTypeValues,
): ITrainingTypeUpsert | undefined => {
  if (!trainingTypeValues) {
    return undefined
  }

  return {
    name: trainingTypeValues?.name,
    objectives: trainingTypeValues?.objectives,
    trainingCategoryId: trainingTypeValues?.trainingCategoryId,
    defaultExpirationMonths: trainingTypeValues?.defaultExpirationMonths,
    acReference: trainingTypeValues?.acReference,
    sortOrder: trainingTypeValues?.sortOrder || '0',
    isActive: trainingTypeValues?.isActive || false,
    documents: trainingTypeValues?.documents || [],
  }
}

export const trainingTypeValuesToTrainingTypeUpdateUpsert = (
  trainingTypeValues: ITrainingTypeValues,
  trainingType: ITrainingType,
): ITrainingTypeUpsert | undefined => {
  if (!trainingTypeValues || !trainingType?.id) {
    return undefined
  }

  return {
    id: trainingType.id,
    name: trainingTypeValues?.name,
    objectives: trainingTypeValues?.objectives,
    trainingCategoryId: trainingTypeValues?.trainingCategoryId,
    defaultExpirationMonths: trainingTypeValues?.defaultExpirationMonths,
    acReference: trainingTypeValues?.acReference,
    sortOrder: trainingTypeValues?.sortOrder,
    isActive: trainingTypeValues?.isActive,
    documents: trainingTypeValues?.documents || [],
  }
}
